import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  IconButton,
  ListItemText,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Typography,
  Skeleton,
  Box,
  Tooltip,
  Paper,
  useTheme,
  TextField,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import "./Calendar.css";
import CloseIcon from "@mui/icons-material/Close";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useProSidebar } from "react-pro-sidebar";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  CalendarpostData,
  DashcalpostData,
} from "../../store/reducers/Formapireducer";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  CheckinAutocomplete,
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
} from "../../ui-components/global/Autocomplete";
import { tokens } from "../../Theme";
import { studentTimetableGet } from "../../store/reducers/Explorelitviewapireducer";
import { getConfig } from "../../config";
import EditTimetablePDF from "../SkillGlow/Pdf/EditTimetablePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
const EditClassTimetable = () => {
  const calendarRef = useRef(null);
  const calendarInstanceRef = useRef(null);
  const [eventsData, setEventsData] = useState([]);
  const [DialogData, setDialogData] = useState([]);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [clickedDate, setClickedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isTodayDialog, setIsTodayDialog] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const [currentDayTasks, setCurrentDayTasks] = useState([]);
  const [yesterdayTasks, setYesterdayTasks] = useState([]);
  const [backlogTasks, setBacklogTasks] = useState([]);
  const [blockedTasks, setBlockedTasks] = useState([]);
  const [footerHeight, setFooterHeight] = useState(60);
const [isReady, setIsReady] = useState(false);

  const [activeTab, setActiveTab] = useState("todo"); // or 'approved'
  const [notApprovedTasks, setNotApprovedTasks] = useState([]);
  const [isToday, setIsToday] = useState(false);
  const isManager = sessionStorage.getItem("isManager");
  const companyClassification = sessionStorage.getItem("Classification");

  console.log(companyClassification, "--companyClassification");
  
  const calendardata = useSelector((state) => state.formApi.calendardata);
  const calenderEmpRecordID = useSelector(
    (state) => state.formApi.calenderEmpRecordID,
  );
  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const d = new Date(date);
  //   return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  // };
  const dispatch = useDispatch();

  const empID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);



  const WCrows = useSelector((state) => state.exploreApi.explorerowData);

  const calendarData = useSelector((state) => state.exploreApi.Data);
// const breakSlots = calendarData?.BreakSlots || [];
// console.log(breakSlots, "--breakSlots");
const breakSlots = Array.isArray(calendarData?.BreakSlots)
  ? calendarData.BreakSlots
  : [];

  const WEEKcolumns = useSelector(
    (state) => state.exploreApi.explorecolumnData,
  );
  const WEEKloading = useSelector((state) => state.exploreApi.loading);
  console.log(WCrows, "--WCrows");
  console.log(WEEKcolumns, "--WEEKcolumns");
  console.log(WEEKloading, "--WEEKloading");






  const [selectedStandard, setSelectedStandard] = useState(null);
  const [selectedTerms, setSelectedTerms] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [tableRows, setTableRows] = useState([]);
  // const [selectedfromdate, setSelectedFromdate] = useState("");
  // const [selectedtodate, setSelectedtodate] = useState("");

  //   const formatDate = (date) => {
  //   const d = new Date(date);
  //   return d.toLocaleDateString("en-GB").split("/").join("-");
  // };
  const HeaderImg = sessionStorage.getItem("CompanyHeader");
  const FooterImg = sessionStorage.getItem("CompanyFooter");
  const config = getConfig();
  const baseurlUAAM = config.UAAM_URL;

  useEffect(() => {
    if (!FooterImg) return;
    const url = `${baseurlUAAM}/uploads/images/${FooterImg}`;
    const img = new Image();
    img.src = url;
    img.onload = () => {
      const aspectRatio = img.height / img.width;
      const pageWidth = 595;
      const MAX_FOOTER_HEIGHT = 80;
      const calculatedHeight = Math.min(
        pageWidth * aspectRatio,
        MAX_FOOTER_HEIGHT
      );
      setFooterHeight(calculatedHeight);
      setIsReady(true);
    };
  }, [FooterImg]);

useEffect(() => {
  setTableRows(WCrows || []);
}, [WCrows]);

  const handleApply = () => {
    if (!selectedStandard) {
      alert("Please select Standards");
      return;
    }
     const TermsID = selectedTerms ? selectedTerms.RecordID : "";
     console.log(TermsID, "--TermsID");
     console.log(selectedTerms, "--selectedTerms");
// return;
    dispatch(
      studentTimetableGet({
        StandardID: selectedStandard?.ProjectID || selectedStandard,
        TermID: TermsID,
        CompanyID: compID
      }),
    );
  };

  const handleReset = () => {
    setSelectedStandard(null);
    setSelectedTerms(null);
    // Clear DataGrid rows
  setTableRows([]);

  };








  
  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        p: 3,
        borderRadius: 3,
      }}
    >
      {/* ================= TITLE ROW ================= */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          // justifyContent: "space-between",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
          // small left margin
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          Weekly TimeTable
        </Typography>

        {/* RIGHT SIDE - LOOKUPS + BUTTONS */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            ml: 1,
          }}
        >
      
          
            <CheckinAutocomplete
       sx={{ width: 200 }}
                           name="ProName"
                           label={
                             <>
                               {/* Project */}
                               Standard
                               <span style={{ color: "red", fontSize: "20px" }}>
                                 {" "}
                                 *{" "}
                               </span>
                             </>
                           }
                           id="ProName"
                           value={selectedStandard}
                          onChange={(newValue) => {
    setSelectedStandard(newValue);
  }}
                          //  error={!!touched.ProName && !!errors.ProName}
                          //  helperText={touched.ProName && errors.ProName}
                           url={`${listViewurl}?data={"Query":{"AccessID":"2191","ScreenName":"Project","Filter":"CompanyID='${compID}' AND EmpID='${EMPID}'","Any":""}}`}
                           // 2054
                         />
            <CheckinAutocomplete
       sx={{ width: 200 }}
                           name="Terms"
                           label={
                             <>
                               {/* Project */}
                              Term
                               <span style={{ color: "red", fontSize: "20px" }}>
                                 {" "}
                                 *{" "}
                               </span>
                             </>
                           }
                           id="Terms"
                           value={selectedTerms}
                          onChange={(newValue) => {
    setSelectedTerms(newValue);
  }}
                          //  error={!!touched.ProName && !!errors.ProName}
                          //  helperText={touched.ProName && errors.ProName}
                           url={`${listViewurl}?data={"Query":{"AccessID":"2192","ScreenName":"Terms","Filter":"StandardID='${selectedStandard?.ProjectID || 0}'","Any":""}}`}
                           // 2054
                         />
   
          <Button
            variant="contained"
            onClick={handleApply}
            sx={{
              backgroundColor: "#2e7c67",
              height: 35,
              "&:hover": {
                backgroundColor: "#256b59",
              },
              ml: 10
            }}
          >
            Apply
          </Button>

{tableRows && tableRows.length > 0 && isReady && (
 <Box sx={{ display: "flex", alignItems: "center" }}>
                      <PDFDownloadLink
                        document={
                          <EditTimetablePDF
                            rows={tableRows || []}
                            columns={WEEKcolumns || []}
                            breakSlots={breakSlots}
                            footerHeight={footerHeight}
                            projectName={selectedStandard ? selectedStandard.Name : ""}
                            termName={selectedTerms ? selectedTerms.Name : ""}
                            filters={{
                              Imageurl: baseurlUAAM,
                              HeaderImg,
                              FooterImg,
                            }}
                          />
                        }
                        fileName={`Timetable_${selectedTerms?.Name || "report"
                          }.pdf`}
                        style={{ color: "#d32f2f", cursor: "pointer" }}
                      >
                        {({ loading }) =>
                          loading ? (
                            <PictureAsPdfIcon
                              sx={{ fontSize: 24, opacity: 0.5 }}
                            />
                          ) : (
                            <PictureAsPdfIcon sx={{ fontSize: 24 }} />
                          )
                        }
                      </PDFDownloadLink>
                    </Box>
)}


          <Button
            variant="contained"
            color="error"
            onClick={handleReset}
            sx={{ height: 35 }}
          >
            Reset
          </Button>
        </Box>
      </Box>

      <Box
       sx={{
                      height: 400,
                      width: "100%",
                      padding: 3,
                      mt: -4,
                      "& .MuiDataGrid-root": {
                        border: "1px solid #e8e8f0",
                        borderRadius: "8px",
                        overflow: "hidden",
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: "#1e1e3a",
                        color: "#c8d0ea",
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: 500,
                        fontSize: "11px",
                        color: "#c8d0ea",
                      },
                      "& .MuiDataGrid-columnHeader": {
                        borderRight: "1px solid #2e2e50",
                      },
                      "& .MuiDataGrid-columnHeader:last-of-type": {
                        borderRight: "none",
                      },
                      "& .MuiDataGrid-iconButtonContainer .MuiIconButton-root":
                        { color: "#8890b8" },
                      "& .MuiDataGrid-columnSeparator": { display: "none" },
                      "& .MuiDataGrid-cell": {
                        borderRight: "0.5px solid #ebebf2",
                        borderBottom: "0.5px solid #ebebf2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "visible !important",
                      },
                      "& .MuiDataGrid-cell:last-of-type": {
                        borderRight: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: "#ffffff",
                      },
                      "& .odd-row": {
                        backgroundColor: "#f8f8fc",
                        color: "#2d2d4a",
                      },
                      "& .even-row": {
                        backgroundColor: "#ffffff",
                        color: "#2d2d4a",
                      },
                      "& .odd-row:hover": {
                        backgroundColor: "#eff0fa !important",
                      },
                      "& .even-row:hover": {
                        backgroundColor: "#eff0fa !important",
                      },
                      "& .MuiDataGrid-row .MuiDataGrid-cell:first-of-type": {
                        backgroundColor: "#f0f0f8",
                        fontWeight: 500,
                        color: "#1e1e3a",
                        borderRight: "2px solid #d0d0e8",
                      },
                    }}
            
      >
        <DataGrid
        //   rows={WCrows}
        rows={tableRows}
          columns={WEEKcolumns}
          loading={WEEKloading}
          pageSizeOptions={[5]}
          hideFooter
          disableRowSelectionOnClick
          rowHeight={50}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
          }
        />
      </Box>

  {breakSlots.length > 0 && (
      <Box
  sx={{
    mt: 2,
    borderTop: "1px solid #dcdcdc",
    pt: 2,
  }}
>
  <Typography
    sx={{
      fontWeight: 700,
      mb: 1.5,
      color: "#333",
    }}
  >
    Intervals
  </Typography>

  <Box
    sx={{
      display: "flex",
      gap: 2,
      flexWrap: "wrap",
    }}
  >
    {breakSlots.map((slot, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.8,
          borderRadius: "8px",
          background: colors.greenAccent[900],
          border: "1px solid #c8dedd",
          boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        {/* Slot Time */}
        <Typography
          sx={{
            fontWeight: 600,
            color: "#1f5f5b",
          }}
        >
          {slot.SlotText}
        </Typography>

        {/* Arrow */}
        <Typography
          sx={{
            fontWeight: 600,
            color: "#888",
          }}
        >
          →
        </Typography>

        {/* Break Name */}
        <Typography
          sx={{
            fontWeight: 700,
            color: "#2e7c67",
          }}
        >
          {slot.SlotName}
        </Typography>
      </Box>
    ))}
  </Box>
</Box>
  )}
    </Paper>
  );
};

export default EditClassTimetable;
